import { toZonedTime } from 'date-fns-tz';

/**
 * Converts a given UTC date to the specified timezone.
 *
 * @param {Date} [date] - The UTC date to convert.
 * @param {string} [timezone] - The target timezone identifier.
 * @returns {Date | null} The date converted to the specified timezone or null if the input date is not provided.
 */
export function utcToTimezone(date?: Date, timezone?: string): Date | null {
  if (!date) {
    return null;
  }
  if (timezone) {
    return toZonedTime(date, timezone);
  }
  return date;
}
